import Service from "../Service";

const resource = "alert/";

export default {
    check(requestID) {
        return Service.post(
            "alert/check", {}, {
                params: { requestID: requestID },
            }
        );
    },

    byAlert(alert, requestID) {
        console.log(alert, requestID);
        return Service.post(
            "transaction/byalert",
            alert, {
                params: { requestID: requestID },
            }
        );
    },

    pagination(dtr, requestID) {
        return Service.post(
            resource + "alertPagination",
            dtr, {
                params: { requestID: requestID },
            }
        );
    },

};